import { Dispatch, SetStateAction, createContext } from 'react';
import { ResearchSheet, UserInfo } from 'types';

export const AuthCtx = createContext<{
  userLoaded: boolean;
  userInfo?: UserInfo;
  setUserInfo?: Dispatch<SetStateAction<UserInfo | undefined>>;
  userSheet?: ResearchSheet;
  setUserSheet?: Dispatch<SetStateAction<ResearchSheet | undefined>>;
  refreshUser: () => Promise<void>;
  researchSheetToDisplayInOrder?: string;
}>({
  userLoaded: false,
  userInfo: undefined,
  setUserInfo: undefined,
  userSheet: undefined,
  setUserSheet: undefined,
  refreshUser: async () => {},
  researchSheetToDisplayInOrder: undefined,
});
